import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ConfigCard from './ConfigCard';

// Pages every webshop has an external-URL override for (SF_LINK_*). Each also
// has internal HTML content (TEXT_* in the `contents` table) editable via the
// parent's `onEditPage(slug)` callback.
// NOTE: the legacy separate "Algemene voorwaarden" link (slug `terms`,
// SF_LINK_TERMS, no content page) was removed from the UI — the disclaimer page
// now IS the terms & conditions (relabelled "Algemene voorwaarden"), and the
// storefront's "I agree to the terms" link already points at the disclaimer
// page. SF_LINK_TERMS still round-trips in state/save, just isn't editable here.
const REQUIRED_PAGES = [
    { slug: 'about',       i18nKey: 'cfg_footer_pages_about',       fallback: 'About'              },
    { slug: 'privacy',     i18nKey: 'cfg_footer_pages_privacy',     fallback: 'Privacy'            },
    { slug: 'disclaimer',  i18nKey: 'cfg_footer_pages_disclaimer',  fallback: 'Terms & conditions' },
];

const PagesAndLinksCard = ({ value = {}, onChange, onEditPage, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const get = (k, fb = '') => (value[k] !== undefined ? value[k] : fb);
    const set = (k) => (v) => onChange && onChange(k, v);

    return (
        <ConfigCard
            anchor="cfg-card-footer-pages"
            title={tr('cfg_footer_pages_title', 'Pages and links')}
            description={tr('cfg_footer_pages_desc', 'Required pages — these always exist. Leave the URL empty to use the internal page.')}
            theme={theme}
        >
            <Stack spacing={1.5}>
                {REQUIRED_PAGES.map(({ slug, i18nKey, fallback }) => (
                    <Box key={slug}>
                        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
                            {tr(i18nKey, fallback)}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'stretch' }}>
                            <TextField
                                size="small"
                                fullWidth
                                value={get(slug)}
                                onChange={(e) => set(slug)(e.target.value)}
                                placeholder={tr('cfg_footer_pages_url_placeholder', 'Leave empty to use the internal page')}
                            />
                            <Button
                                size="small"
                                variant="outlined"
                                startIcon={<EditIcon />}
                                onClick={() => onEditPage && onEditPage(slug)}
                                sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                            >
                                {tr('cfg_footer_pages_edit', 'Edit page')}
                            </Button>
                        </Box>
                    </Box>
                ))}
            </Stack>
        </ConfigCard>
    );
};

PagesAndLinksCard.propTypes = {
    value:      PropTypes.object,
    onChange:   PropTypes.func,
    onEditPage: PropTypes.func,
    theme:      PropTypes.string,
    t:          PropTypes.func,
};

export default PagesAndLinksCard;
